import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Loader2, MailCheck } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import api from '../api';

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Please enter your email'); return; }
    setBusy(true);
    try {
      await api.post('/auth/request-reset', { email, origin: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background px-5 py-6">
      <button onClick={() => nav('/auth')} className="mb-6 inline-flex h-10 w-10 items-center justify-center rounded-full hover:bg-secondary"><ChevronLeft className="h-5 w-5" /></button>
      <div className="mx-auto max-w-md animate-fade-up">
        {!sent ? (
          <>
            <h1 className="text-3xl font-extrabold tracking-tight">Forgot password?</h1>
            <p className="mt-2 text-muted-foreground">Enter your email and we'll send you a link to reset it.</p>
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
              <div>
                <Label className="text-sm font-semibold">Email</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="forgot-email" className="mt-1.5 h-12 rounded-xl bg-white" />
              </div>
              <button type="submit" disabled={busy} data-testid="forgot-submit" className="coral-btn flex w-full items-center justify-center gap-2 rounded-2xl py-4 text-base font-bold text-white disabled:opacity-70">
                {busy && <Loader2 className="h-5 w-5 animate-spin" />}Send reset link
              </button>
            </form>
          </>
        ) : (
          <div className="rounded-3xl bg-white p-7 text-center card-soft" data-testid="forgot-sent">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-accent"><MailCheck className="h-7 w-7 text-[hsl(var(--coral))]" /></div>
            <h1 className="mt-4 text-2xl font-extrabold">Check your email</h1>
            <p className="mt-2 text-sm text-muted-foreground">If an account exists for <b>{email}</b>, we've sent a password-reset link. It expires in 30 minutes.</p>
            <button onClick={() => nav('/auth')} className="coral-btn mt-6 w-full rounded-2xl py-3.5 text-base font-bold text-white">Back to sign in</button>
          </div>
        )}
      </div>
    </div>
  );
}
